import { render, staticRenderFns } from "./PreCommunicationForExecutives.vue?vue&type=template&id=71bb72b2&scoped=true"
import script from "./PreCommunicationForExecutives.vue?vue&type=script&lang=js"
export * from "./PreCommunicationForExecutives.vue?vue&type=script&lang=js"
import style0 from "./PreCommunicationForExecutives.vue?vue&type=style&index=0&id=71bb72b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bb72b2",
  null
  
)

export default component.exports